(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["litos-header"] && !Shopify.designMode) return;
  try {
    
  class LitosHeader extends HTMLElement {
    connectedCallback() {
      this.mobile = window.matchMedia('(max-width: 1024px)');

      this.toggle = this.querySelector('[data-litos-toggle]');
      this.toggle?.addEventListener('click', () => {
        const open = this.classList.toggle('is-open');
        this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        // Lock background scroll while the fullscreen menu is open.
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (!open) this.collapseAll();
      });

      // On mobile, tapping a parent link toggles its submenu (accordion)
      // instead of navigating.
      this.querySelectorAll('.litos-header__item--has-children > .litos-header__link').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (!this.mobile.matches) return;
          event.preventDefault();
          link.closest('.litos-header__item').classList.toggle('is-expanded');
        });
      });
    }

    collapseAll() {
      this.querySelectorAll('.litos-header__item.is-expanded').forEach((item) => {
        item.classList.remove('is-expanded');
      });
    }
  }
  customElements.define('litos-header', LitosHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["litos-service-list"] && !Shopify.designMode) return;
  try {
    
  class LitosServiceList extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-reveal') || !window.IntersectionObserver) {
        this.classList.remove('is-reveal-ready');
        return;
      }

      // The inline script normally sets this before first paint; re-add it for theme
      // editor re-renders, where inline scripts don't run.
      this.classList.add('is-reveal-ready');

      // Fade in on enter, fade back out on leave, so the effect replays both ways.
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-visible', entry.isIntersecting);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
      );

      this.querySelectorAll('.litos-reveal').forEach((el) => this.observer.observe(el));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }
  customElements.define('litos-service-list', LitosServiceList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["litos-values"] && !Shopify.designMode) return;
  try {
    
  class LitosValues extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('.litos-values__swiper');
      this.paginationEl = this.querySelector('.litos-values__pagination');
      if (!this.swiperEl) return;

      // Slider only on mobile; static grid on larger screens.
      this.mql = window.matchMedia('(max-width: 767px)');
      this.handleChange = () => this.sync();
      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.handleChange);
      } else {
        this.mql.addListener(this.handleChange);
      }
      this.waitForSwiper();
    }

    waitForSwiper() {
      if (typeof window.Swiper === 'undefined') {
        return window.setTimeout(() => this.waitForSwiper(), 50);
      }
      this.sync();
    }

    sync() {
      if (this.mql.matches) {
        this.create();
      } else {
        this.destroy();
      }
    }

    create() {
      if (this.instance) return;
      this.instance = new window.Swiper(this.swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 32,
        grabCursor: true,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        pagination: this.paginationEl ? { el: this.paginationEl, clickable: true } : false
      });
      // Recompute after layout/fonts settle so positions match the active index.
      requestAnimationFrame(() => this.instance && this.instance.update());
    }

    destroy() {
      if (this.instance) {
        this.instance.destroy(true, true);
        this.instance = null;
      }
    }
  }

  customElements.define('litos-values', LitosValues);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
